import { Component, Children } from "react";
import PropTypes from "prop-types";
import Header from "@components/base/header";
import Footer from "@components/base/footer";

export default class BaseComponet extends Component {
  constructor(props, context) {
    super(props, context);
    this.init(props);
  }

  componentWillReceiveProps(nextProps) {
    this.init(nextProps);
  }

  init(props) {
    this.header = [];
    this.footer = [];
    this.content = [];
    Children.forEach(props.children, child => {
      switch (child && child.type) {
        case Header:
          this.header.push(child.props.children);
          break;
        case Footer:
          this.footer.push(child.props.children);
          break;
        default:
          this.content.push(child);
      }
    });
  }
  /**
   * @overide render
   */
}

BaseComponet.propTypes = {
  children: PropTypes.any, // eslint-disable-line
};

export { Header, Footer };
